import { Modal } from 'bootstrap';

export default {
  props: {
    name: { type: String, required: true },
    size: { type: String, default: '' },
    centered: { type: Boolean, default: false },
    scrollable: { type: Boolean, default: false },
    closable: { type: Boolean, default: false },
  },
  emits: ['show', 'hide'],
  data: () => ({ instance: null }),
  watch: {
    '$route'(value) {
      if (value.query.modal && value.query.modal === this.name) {
        this.instance.show();
        this.$emit('show');
      } else {
        setTimeout(() => this.$emit('hide'), 200);
        this.instance.hide();
      }
    },
  },
  mounted() {
    this.$route.query.modal && this.$router.replace({ query: {} }).catch(() => {});
    this.instance = Modal.getOrCreateInstance(this.$refs.modal);
    document.addEventListener('keyup', this.escape);
  },
  beforeUnmount() {
    this.instance.dispose();
    document.removeEventListener('keyup', this.escape);
  },
  methods: {
    show_() { this.$router.push({ query: { modal: this.name } }).catch(() => {}); },
    hide_() { this.$router.back(); },
    escape(event) {
      if (!this.instance._isShown || this.instance._isTransitioning) return;
      if (event.code === 'Escape' && this.$route.query.modal) this.hide_();
    },
  },
};
